<div
    [id]="getWidgetId"
    [class.mobileWidgetViewWrap]="isDeviceMobile$ | async"
    [class]="classes?.imgWidgetWrapper"
    class="img-widget-width"
>
    <div
        class="before-after-wrapper"
        [class]="classes?.imgWrapper"
        #resizeBox
        #animatedElem
        mwlResizable
        (resizeStart)="onResizeStart($event, resizeBox)"
        (resizing)="onResizing($event, resizeBox)"
        (resizeEnd)="onResizeEnd($event, resizeBox)"
        [style.paddingTop.%]="getBeforeImagePaddingTop(beforeImage || afterImage)"
    >
        <!-- Before Image -->

        <img
            #beforeImageRef
            [class]="classes?.image"
            [src]="beforeImgSrc"
            [spFallbackImage]="beforeImgFallbackSrc"
            [alt]="beforeImage?.alt"
            [style.objectPosition]="
                beforeImage &&
                (beforeImage.backgroundPositionX || 50) + '% ' + (beforeImage.backgroundPositionY || 50) + '%'
            "
            (mousedown)="mouseDown($event, beforeImage)"
            (mousemove)="move($event, beforeImageRef)"
            (mouseleave)="mouseUp('before')"
            (mouseup)="mouseUp('before')"
        />

        <div [class]="classes.afterImageWrapper" [ngStyle]="getAfterImageClipStyle()">
            <img
                #afterImageRef
                [class]="classes?.afterImage"
                [src]="afterImgSrc"
                [spFallbackImage]="afterImgFallbackSrc"
                [alt]="afterImage?.alt"
                [style.objectPosition]="
                    afterImage &&
                    (afterImage.backgroundPositionX || 50) + '% ' + (afterImage.backgroundPositionY || 50) + '%'
                "
                (mousedown)="mouseDown($event, afterImage)"
                (mousemove)="move($event, afterImageRef)"
                (mouseleave)="mouseUp('after')"
                (mouseup)="mouseUp('after')"
            />
        </div>

        <ng-container *ngIf="beforeImage || afterImage">
            <!-- Slider Handle -->
            <div
                [class]="classes.sliderHandle"
                [ngStyle]="getSliderHandleStyle()"
                class="slider-handle"
                [class.horizontal]="widgetData.handleOrientation === EHandleOrientation.horizontal"
                (mousedown)="startDragging($event)"
                (touchstart)="startDragging($event)"
            >
                <div class="handle-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path
                            d="M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z"
                            fill="currentColor"
                            fill-opacity="0.1"
                        />
                        <path
                            d="M36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36V40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40V36C28.8366 36 36 28.8366 36 20Z"
                            fill="currentColor"
                        />
                        <path
                            d="M11.95 14.4019L8.2 19.4019C7.93333 19.7575 7.93333 20.2464 8.2 20.6019L11.95 25.6019C12.5266 26.3707 14 25.961 14 25V15C14 14.039 12.5266 13.6331 11.95 14.4019Z"
                            fill="currentColor"
                        />
                        <path
                            d="M28.05 14.4019L31.8 19.4019C32.0667 19.7575 32.0667 20.2464 31.8 20.6019L28.05 25.6019C27.4734 26.3707 26 25.961 26 25V15C26 14.039 27.4734 13.6331 28.05 14.4019Z"
                            fill="currentColor"
                        />
                    </svg>
                </div>
            </div>

            <!-- Slider Border -->
            <div [class]="classes.sliderBorder" [ngStyle]="getSliderBorderStyles()"></div>
        </ng-container>

        <div *ngIf="beforeImage && afterImage">
            <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path
                            d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                            fill="white"
                        />
                    </g>
                </svg>
            </div>
        </div>
    </div>
</div>
